import { Contract } from '@vy/types';
import { isNullOrUndefined } from '@vy/utils';
import { formatDate } from '../../../../../utils/date';

const EMPTY_FIELD_DISPLAY = '-';

export function formatSignatureDate(signatureDate: Date | null | undefined): string {
  return isNullOrUndefined(signatureDate) ? '--' : formatDate(signatureDate);
}

export function getContractDetailItems(contract: Contract) {
  const duration =
    contract.plan.billingData.duration === -1 ? 'Recurring' : `${contract.plan.billingData.duration} months`;

  const isAutoRenewalEnabled = contract.plan.billingData.autoRenewal;
  const contractEndDate = isNullOrUndefined(contract.endDate)
    ? 'N/A'
    : formatDate(contract.endDate, 'MMM D, YYYY');
  const creationDate = isNullOrUndefined(contract.createdAt)
    ? 'N/A'
    : formatDate(contract.createdAt, 'MMM D, YYYY');

  const purchaseOrderFieldKey = 'purchaseOrder' as const;
  const notesFieldKey = 'notes' as const;
  const purchaseOrderValue = contract.plan.purchaseOrder ?? EMPTY_FIELD_DISPLAY;
  const notesValue = contract.notes ?? EMPTY_FIELD_DISPLAY;

  return [
    { label: 'Duration', value: duration },
    { label: 'PO number', value: purchaseOrderValue, editable: true, fieldKey: purchaseOrderFieldKey },
    { label: 'Memo', value: notesValue, editable: true, fieldKey: notesFieldKey },
    {
      label: 'Signature Date',
      value: formatSignatureDate(contract.signatureDate),
    },
    { label: 'Creation Date', value: creationDate },
    ...(isAutoRenewalEnabled ? [{ label: 'Renewal Date', value: contractEndDate }] : []),
  ];
}

export function getParentAgreementDetailItems(contract: Contract) {
  return [
    {
      label: 'Plan type',
      value: 'Reseller Agreement',
    },
    {
      label: 'Start date',
      value: formatDate(contract.startDate),
    },
    {
      label: 'Signature date',
      value: formatSignatureDate(contract.signatureDate),
    },
    ...(contract.plan.purchaseOrder
      ? [
          {
            label: 'PO number',
            value: contract.plan.purchaseOrder,
          },
        ]
      : []),
  ];
}
